import { CSSObject, Theme, forBrands } from '@core-ui/react-stitch';

const setMenuStylesForBananaRepublic = (theme: Theme,isBRcolor2023FFEnabled:boolean): CSSObject => ({
  backgroundColor: isBRcolor2023FFEnabled ? "#F6F4EB" : theme.color.inverse.b1,
  boxShadow: 'none',
  width: '6.25rem',
  '&[aria-activedescendant]': {
    border: isBRcolor2023FFEnabled ? "0.063rem solid #000000" : `0.063rem solid ${theme.color.b2}`,
  },
});

const getMenuStyles =
  (isBRcolor2023FFEnabled:boolean) =>
  (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
    ...base,
    ...(forBrands(theme, {
      br: setMenuStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
      brfs: setMenuStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
    }) as CSSObject),
  });

export default getMenuStyles;
